import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/data/site";

const EASE = [0.76, 0, 0.24, 1];

export const Membro = () => {
    const [form, setForm] = useState({
        nome: "",
        email: "",
        cidade: "",
        interesse: "voluntario",
        mensagem: "",
    });

    const onSubmit = (e) => {
        e.preventDefault();
        const msg =
            `*[Seja Membro — Novo Horizonte]*\n\n` +
            `*Nome:* ${form.nome}\n` +
            `*Email:* ${form.email}\n` +
            `*Cidade:* ${form.cidade}\n` +
            `*Interesse:* ${form.interesse}\n\n` +
            `*Mensagem:*\n${form.mensagem}`;
        const url = `https://wa.me/5594992821992?text=${encodeURIComponent(msg)}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    return (
        <section
            id="membro"
            data-testid="membro-section"
            className="relative bg-[var(--sun)] text-[var(--ink)] py-24 md:py-32 overflow-hidden"
        >
            <div className="container-x">
                <div className="grid grid-cols-12 gap-6 mb-14 md:mb-16">
                    <div className="col-span-12 md:col-span-8">
                        <div className="flex items-center gap-3 text-[11px] tracking-[0.32em] uppercase text-[var(--ink)]/60 font-body">
                            <span className="inline-block h-px w-10 bg-[var(--ink)]/40" />
                            <span>Seção 04</span>
                        </div>
                        <motion.h2
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.9, ease: EASE }}
                            data-testid="membro-title"
                            className="font-display text-[16vw] md:text-[10vw] lg:text-[8.5vw] mt-6"
                        >
                            Faça <br />
                            <span className="font-editorial italic font-medium">
                                parte.
                            </span>
                        </motion.h2>
                    </div>
                    <div className="col-span-12 md:col-span-4 md:col-start-9 flex items-end">
                        <p className="font-body text-[15px] leading-relaxed text-[var(--ink)]/85">
                            Torne-se voluntário, apoiador, parceiro ou padrinho
                            de uma criança. Toda contribuição — de tempo,
                            recurso ou material — vira futuro em campo.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-8">
                    {/* Form */}
                    <motion.form
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
                        onSubmit={onSubmit}
                        data-testid="membro-form"
                        className="col-span-12 md:col-span-7 border-2 border-[var(--ink)] bg-[var(--sun-2)]/40 p-6 md:p-10"
                    >
                        <div className="grid grid-cols-2 gap-5">
                            <label className="col-span-2 md:col-span-1 flex flex-col gap-2">
                                <span className="text-[10px] tracking-[0.32em] uppercase font-body">
                                    Nome
                                </span>
                                <input
                                    required
                                    data-testid="input-nome"
                                    value={form.nome}
                                    onChange={set("nome")}
                                    type="text"
                                    className="bg-transparent border-b-2 border-[var(--ink)] py-2 font-editorial italic text-2xl focus:outline-none placeholder:text-[var(--ink)]/30"
                                    placeholder="Seu nome completo"
                                />
                            </label>
                            <label className="col-span-2 md:col-span-1 flex flex-col gap-2">
                                <span className="text-[10px] tracking-[0.32em] uppercase font-body">
                                    Email
                                </span>
                                <input
                                    required
                                    data-testid="input-email"
                                    value={form.email}
                                    onChange={set("email")}
                                    type="email"
                                    className="bg-transparent border-b-2 border-[var(--ink)] py-2 font-editorial italic text-2xl focus:outline-none placeholder:text-[var(--ink)]/30"
                                    placeholder="voce@email.com"
                                />
                            </label>
                            <label className="col-span-2 md:col-span-1 flex flex-col gap-2">
                                <span className="text-[10px] tracking-[0.32em] uppercase font-body">
                                    Cidade
                                </span>
                                <input
                                    data-testid="input-cidade"
                                    value={form.cidade}
                                    onChange={set("cidade")}
                                    type="text"
                                    className="bg-transparent border-b-2 border-[var(--ink)] py-2 font-editorial italic text-2xl focus:outline-none placeholder:text-[var(--ink)]/30"
                                    placeholder="Canaã dos Carajás"
                                />
                            </label>
                            <label className="col-span-2 md:col-span-1 flex flex-col gap-2">
                                <span className="text-[10px] tracking-[0.32em] uppercase font-body">
                                    Interesse
                                </span>
                                <select
                                    data-testid="select-interesse"
                                    value={form.interesse}
                                    onChange={set("interesse")}
                                    className="bg-transparent border-b-2 border-[var(--ink)] py-2 font-editorial italic text-2xl focus:outline-none"
                                >
                                    <option value="voluntario">
                                        Voluntário
                                    </option>
                                    <option value="apoiador">Apoiador</option>
                                    <option value="parceiro">Parceiro</option>
                                    <option value="padrinho">
                                        Padrinho / Madrinha
                                    </option>
                                    <option value="doacao">Doação</option>
                                </select>
                            </label>
                            <label className="col-span-2 flex flex-col gap-2">
                                <span className="text-[10px] tracking-[0.32em] uppercase font-body">
                                    Mensagem
                                </span>
                                <textarea
                                    data-testid="input-mensagem"
                                    value={form.mensagem}
                                    onChange={set("mensagem")}
                                    rows={3}
                                    className="bg-transparent border-b-2 border-[var(--ink)] py-2 font-editorial italic text-xl focus:outline-none resize-none placeholder:text-[var(--ink)]/30"
                                    placeholder="Conte um pouco sobre como quer participar."
                                />
                            </label>
                        </div>

                        <div className="mt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                            <span className="text-[10px] tracking-[0.32em] uppercase font-body text-[var(--ink)]/60">
                                * Envia direto pelo WhatsApp
                            </span>
                            <button
                                type="submit"
                                data-testid="membro-submit"
                                className="btn-brutal bg-[var(--ink)] text-[var(--sun)] border-[var(--ink)]"
                                style={{
                                    boxShadow: "6px 6px 0 rgba(0,0,0,0.35)",
                                }}
                            >
                                Enviar pelo WhatsApp
                                <ArrowUpRight size={16} strokeWidth={2.5} />
                            </button>
                        </div>
                    </motion.form>

                    {/* Side info */}
                    <div className="col-span-12 md:col-span-4 md:col-start-9 flex flex-col justify-between gap-8">
                        <div className="border-2 border-[var(--ink)] p-6">
                            <div className="font-display text-[11px] tracking-[0.32em] uppercase text-[var(--ink)]/70">
                                Projeto atual
                            </div>
                            <p className="mt-3 font-editorial italic text-xl leading-tight">
                                Meninas Vencedoras no Campo e na Comunidade — 2025 · 2026
                            </p>
                            <div className="mt-4 text-[10px] tracking-[0.32em] uppercase text-[var(--ink)]/60 font-body">
                                Patrocínio
                            </div>
                            <p className="mt-1 font-body text-sm">
                                Eletrobras · Ministério do Esporte · Lei de
                                Incentivo ao Esporte · Governo Federal
                            </p>
                        </div>
                        <div>
                            <div className="font-display text-[11px] tracking-[0.32em] uppercase text-[var(--ink)]/70">
                                Contato direto
                            </div>
                            <div className="mt-3 flex flex-col gap-2">
                                {SITE.phones.map((p) => (
                                    <a
                                        key={p}
                                        href={`tel:${p.replace(/\D/g, "")}`}
                                        data-testid={`membro-phone-${p}`}
                                        className="block font-display text-2xl md:text-3xl link-sweep w-fit"
                                    >
                                        {p}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
